import React from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Typography, message, Input } from "antd";
import { ArrowLeftOutlined, MailOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import GradientButton from "../../../components/button/gradientButton";

import './index.css';

const { Title } = Typography;

const ForgotPassword = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const onFinish = (values) => {
        message.success(t('PASSWORD_RESET_LINK_SENT'));
        navigate("/login"); 
    };

    const goBack = () => {
        navigate("/login");
    };

    return (
        <Row justify="center" align="middle" style={{ height: "100vh", backgroundColor: "#f7f7f7" }}>
            <Col xs={22} sm={18} md={12} lg={8} style={{ background: "white", padding: "30px", borderRadius: "10px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
                <ArrowLeftOutlined
                    style={{ fontSize: "20px", cursor: "pointer", marginBottom: "20px" }}
                    onClick={goBack}
                />
                <Title level={3} className="auth-title">{t('FORGOT_PASSWORD')}</Title>
                <Form
                    name="forgot_password"
                    className="auth-form"
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Form.Item
                        name="email"
                        label={t('EMAIL')}
                        rules={[
                            {
                                type: "email",
                                message: t('INVALID_EMAIL'),
                            },
                            {
                                required: true,
                                message: t('ENTER_EMAIL'),
                            },
                        ]}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            placeholder={t('ENTER_EMAIL')}
                        />
                    </Form.Item>
                    <Form.Item>
                        <GradientButton
                            type="primary"
                            htmlType="submit"
                            size="large"
                        >
                            {t('RESET_PASSWORD')}
                        </GradientButton>
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
};

export default ForgotPassword;
